import React from 'react';
import { useTranslation } from '@refinedev/core';
import {
  QuickStatusFilterButtons,
  StatusFilterButtonItem,
} from 'components/common';
import {
  ClaimQueryStatusGroup,
  ClaimQueryStatusGroupCounts,
  formatClaimQueryStatusGroupLabel,
} from './queryStatus';

interface QueryStatusQuickFiltersProps {
  activeGroup: ClaimQueryStatusGroup | null;
  onGroupChange: (group: ClaimQueryStatusGroup) => void;
  statusGroupCounts: ClaimQueryStatusGroupCounts;
}

const orderedGroups: ClaimQueryStatusGroup[] = [
  ClaimQueryStatusGroup.all,
  ClaimQueryStatusGroup.created,
  ClaimQueryStatusGroup.submitted,
  ClaimQueryStatusGroup.pending,
  ClaimQueryStatusGroup.completed,
  ClaimQueryStatusGroup.failed,
];

export const QueryStatusQuickFilters: React.FC<
  QueryStatusQuickFiltersProps
> = ({ activeGroup, onGroupChange, statusGroupCounts }) => {
  const { translate } = useTranslation();

  const items: StatusFilterButtonItem<ClaimQueryStatusGroup>[] =
    orderedGroups.map((group) => ({
      key: group,
      label: formatClaimQueryStatusGroupLabel(group, translate),
      count: statusGroupCounts[group] ?? 0,
      active: activeGroup === group,
      dataTestId: `query-status-filter-${group}`,
    }));

  return (
    <QuickStatusFilterButtons
      items={items}
      topKeys={orderedGroups}
      onSelect={onGroupChange}
    />
  );
};
